import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=9ef3f1bc&scoped=true"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=9ef3f1bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef3f1bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ef3f1bc')) {
      api.createRecord('9ef3f1bc', component.options)
    } else {
      api.reload('9ef3f1bc', component.options)
    }
    module.hot.accept("./policyDetail.vue?vue&type=template&id=9ef3f1bc&scoped=true", function () {
      api.rerender('9ef3f1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/policyDetail.vue"
export default component.exports